import Box from '@mui/material/Box';
import {ReactComponent as IndexBannerInfoIcon} from '../../../../src/assests/svg/index_info.svg';
import {Typography} from '@mui/material';

interface IIndexingBanner {
  message: string | null;
}

const IndexingBanner: React.FC<IIndexingBanner> = ({message}) => {
  return (
    <Box className="indexing-banner">
      <IndexBannerInfoIcon aria-hidden={true} data-testid="index-info-icon" />
      <Typography
        className="index-status-message typo-text label2_size index-message-text"
        aria-live="polite"
        aria-atomic="true"
      >
        {message}
      </Typography>
    </Box>
  );
};

export default IndexingBanner;
